export default __webpack_public_path__ + "static/media/talk.e6361b9d.png";